/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

document.addEventListener('DOMContentLoaded', function() {
  // Get all video-media elements
const videoMediaElements = document.querySelectorAll('product-images video-media');

// Process each video-media element
videoMediaElements.forEach(element => {
  // Get video and button elements within this video-media
  const video = element.querySelector('video');
  const muteBtn = element.querySelector('button#muteBtn'); // Assuming button is the only button element
  
  // Skip if elements not found
  if (!video || !muteBtn) return;
  
  // Set initial state
  let isMuted = false;
  
  // Add click event to button
  muteBtn.addEventListener('click', () => {
    // Toggle mute state
    isMuted = !isMuted;
    video.muted = isMuted;
    
    // Update button appearance and text
    if (isMuted) {
      muteBtn.innerHTML = '🔇 Unmute';

    } else {
      muteBtn.innerHTML = '🔊 Mute';
    }
  });
  
  // Optional: Update button when video's mute state changes externally
  video.addEventListener('volumechange', () => {
    isMuted = video.muted;
    if (isMuted) {
      muteBtn.innerHTML = '🔇 Unmute';
    } else {
      muteBtn.innerHTML = '🔊 Mute';
    }
  });
});
})

